import { OktaAuth } from '@okta/okta-auth-js';
import { environment } from '@brighthub/environment';

const authConfig = {
  issuer: 'https://brightsidebenefit.okta.com/oauth2/default',
  clientId:  environment.oktaClientId,
  redirectUri: window.location.origin + '/login/callback',
  scopes: ['openid', 'profile', 'email', 'offline_access', 'user.info'],
  pkce: true,
  tokenManager: {
    secure: true,
    autoRenew: true,
    autoRemove: true,
    expireEarlySeconds: 30,
    syncStorage: true,
  },
}
export const oktaAuthComplete = new OktaAuth(authConfig);
